export default "__VITE_ASSET__6cdb3bfe__"